enum UserRole {
  MANAGER = 'MANAGER',
  CLIENT = 'CLIENT',
  ADMIN = 'ADMIN',
}

export default UserRole;
